export default () => ({
    is_initialized: false,
    is_intersected: false,
    is_locked: true,
    form_action: '',
    form_defaults: {
        phone: '',
        email: '',
        name: '',
        message: '',
        answer: null,
        agree: false,
    },
    form: {},
    errors: {},
    error_message: '',
    success_message: '',

    init() {
        this.resetFormData();

        // noinspection JSUnresolvedReference
        this.form_action    = this.$root.getAttribute('data-action');
        this.is_locked      = false;
        this.is_initialized = true;

        // Сброс ошибок валидации при вводе
        // noinspection JSUnresolvedReference
        Object.keys(this.form_defaults).forEach(field => {
            this.$watch(`form.${field}`, () => {
                if (this.errors[field]) {
                    delete this.errors[field];
                }
            });
        });
    },

    resetValidation() {
        this.errors          = {};
        this.error_message   = '';
    },

    resetFormData() {
        Object.assign(this.form, this.form_defaults);
    },

    send() {
        this.resetValidation();
        this.success_message = '';
        this.is_locked = true;

        // noinspection JSUnresolvedReference
        this.form.payload = this.$root.getAttribute('data-payload');

        // Событие о попытке отправки формы
        Alpine.store('global').dispatchFormAttemptEvent(this.form_action, this.form);

        // Маршрут
        const route = window["yep_ajax"].url + '?action=' + this.form_action;

        // Отправка формы
        return axios.postForm(route, this.form).then(response => {
            this.success_message = response.data?.message ?? '';

            if (this.success_message) {
                // Событие об успешной отправке формы
                Alpine.store('global').dispatchFormSuccessEvent(this.form_action, this.form, response.data);
                this.resetValidation();
                this.resetFormData();
            } else {
                this.error_message = 'Что-то пошло не так…';
            }
        }).catch(error => {
            // Ошибка подключения
            if (error.code === 'ERR_NETWORK') {
                this.errors = {};
                console.error('network error', error);
                Alpine.nextTick().then(() => {
                    this.error_message = 'Проверьте подключение к интернету и повторите попытку.';
                })
                return;
            }

            // Ошибка валидации данных
            if (error.response.status === 422) {
                this.errors        = error.response.data.errors ?? [];
                this.error_message = error.response.data?.message ?? null;
                this.focusInvalidField();
                return;
            }

            // Другая ошибка
            this.error_message = error.response?.data?.message ?? 'Произошла ошибка.';
            console.error('error response', error.response);
        }).finally(() => {
            this.is_locked = false;
        });
    },

    focusInvalidField() {
        setTimeout(() => {
            // noinspection JSUnresolvedReference
            this.$root.querySelector('input.is-invalid')?.focus();
        }, 250);
    }

})